angular.module('unergie.main')
.directive('userInfoContractPayment', ($sce, $filter, $window, BoFeaturesService) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractPayment.html',
        link($scope) {
            $scope.adjustments = BoFeaturesService.getModuleFeatures('contracts').adjustments
            $scope.displayBalanceExplanation = BoFeaturesService.getModuleFeatures('contracts').displayBalanceExplanation
        },
    })
)
